import * as React from 'react';
import './ReportingTagsPage.scss';

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as ReportingTagActions from '../../../actions/reportingTags';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { QALookupsLayout } from '../../index';

interface IReportingTagsPageProps {

    location: Location;
    history: History;

    // From state
    formFilter: IFormFilter;
    reportingTags: Dtos.ReportingTag[];
    loadingReportingTags: boolean;
    loadReportingTagsSuccess: boolean;
    loadReportingTagsFailure: boolean;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    formRoles?: Dtos.RoleType[];
}

interface IReportingTagsPageActions {
    clearReportingTags: ReportingTagActions.IReportingTagClearActionCreator;
    loadReportingTags: ReportingTagActions.IReportingTagLoadActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    filter: ReportingTagActions.IReportingTagFilterActionCreator;
}

type ReportingTagsPageProps = IReportingTagsPageProps & IReportingTagsPageActions;

class ReportingTagsPage extends React.PureComponent<ReportingTagsPageProps, any> {

    constructor(props: ReportingTagsPageProps) {
        super(props);

        this.clearReportingTags = this.clearReportingTags.bind(this);
    }

    componentDidMount() {
        const {
            loadReportingTags
        } = this.props;

        loadReportingTags();
    }

    componentWillReceiveProps(nextProps: ReportingTagsPageProps) {
    }

    componentDidUpdate(prevProps: ReportingTagsPageProps, prevState) {
        const {
            navigateReplace
        } = this.props
    }

    componentWillUpdate(nextProps: ReportingTagsPageProps) {
    }

    componentWillUnmount() {
        this.clearReportingTags();
    }

    clearReportingTags() {
        this.props.clearReportingTags();
    }

    showReportingTags(): boolean {
        const {
            loadingReportingTags,
            loadReportingTagsSuccess
        } = this.props

        if (!loadingReportingTags && loadReportingTagsSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingReportingTags
        } = this.props;

        return <QALookupsLayout loading={loadingReportingTags} permission={Dtos.Permission.ReportingTagsView}>
            {this.renderContent()}
        </QALookupsLayout>;
    }

    renderContent() {
        const {
            permissions
        } = this.props;

        return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Reporting Tags</h2>
                </div>
                <div className="col-6" style={{ textAlign: 'right' }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e) } />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ReportingTagsCreate) && (
                        <Link className={"btn btn-primary"} url={"/settings/qa/reportingTags/create"}>Create</Link>
                    )}
                </div>
            </div>
            {
                !this.showReportingTags() ?
                    "Loading ReportingTags" :
                    null
            }
            {
                this.showReportingTags() ?
                    <div className="patient-tables mt-2">
                        {
                            this.createTable()
                        }
                    </div> :
                    null
            }
        </div>
    }

    createTable() {

        const {
            reportingTags
        } = this.props

        if (!reportingTags || reportingTags.length == 0) {
            return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no reportingTags to view.</span>
            </div>
        }

        const showPagination = reportingTags.length > DEFAULT_PAGE_SIZE;

        return <div className="table-wrapper mb-3">
            <ReactTable
                data={reportingTags}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : reportingTags.length}
                pageSize={showPagination ? undefined : reportingTags.length}
                showPagination={showPagination}
                className="-striped -highlight -clickable mb-3"
                noDataText="There are currently no reportingTag to display"
                resizable={false}
                getTdProps={(state, rowInfo: RowInfo, column, instance) => {
                    return {
                        onClick: (e, handleOriginal) => {

                            const url: string = "/settings/qa/reportingTags/" + rowInfo.original.id;
                            this.props.navigate(url);

                            if (handleOriginal) {
                                handleOriginal()
                            }

                        },
                        style: {
                            color: (rowInfo && rowInfo.original && rowInfo.original.active) ? '#212529' : '#9e9e9e'
                        }
                    }
                }}
                columns={[
                    {
                        id: "id",
                        Header: ' ',
                        accessor: "id",
                        className: "d-flex align-items-center justify-content-center",
                        maxWidth: 50,
                        Cell: (props) => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
                    },
                    {
                        id: "value",
                        Header: 'Name',
                        accessor: 'value',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left"
                    },
                    {
                        id: "category",
                        Header: 'Category',
                        accessor: 'reportingTagCategory.value',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left"
                    }
                ]}
            />
        </div>

    }

}

const mapStateToProps = (state: ITmdState, ownProps: ReportingTagsPageProps): IReportingTagsPageProps => {

    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        history: ownProps.history,
        location: state.routing.location,

        formFilter: state.reportingTags.formFilter,
        reportingTags: state.reportingTags.formFilteredData, 

        loadingReportingTags: state.reportingTags.loadState && state.reportingTags.loadState.status == RequestState.Pending,
        loadReportingTagsSuccess: state.reportingTags.loadState && state.reportingTags.loadState.status == RequestState.Success,
        loadReportingTagsFailure: state.reportingTags.loadState && state.reportingTags.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        formRoles: state.user.formRoles
    };
};

const mapDispatchToProps = (dispatch): IReportingTagsPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadReportingTags: bindActionCreators(ReportingTagActions.LoadReportingTag, dispatch),
        clearReportingTags: bindActionCreators(ReportingTagActions.Clear, dispatch),

        filter: bindActionCreators(ReportingTagActions.Filter, dispatch),
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(ReportingTagsPage);
